
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CartProductBillingItemsGrid extends Serenity.EntityGrid<CartProductBillingItemsRow, any> {
        protected getColumnsKey() { return CartProductBillingItemsColumns.columnsKey; }
        protected getDialogType() { return CartProductBillingItemsDialog; }
        protected getIdProperty() { return CartProductBillingItemsRow.idProperty; }
        protected getInsertPermission() { return CartProductBillingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return CartProductBillingItemsRow.localTextPrefix; }
        protected getService() { return CartProductBillingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}